export const FILE_SIZE_LIMIT = 20;
export const FILE_TYPE_ALLOWED = 'png,jpg,jpeg';
